import React from 'react'

const SecondaryButton = ({ url, text, newWindow }) => (
  <div className="columns is-centered cta-padding">
    <a href={url} target={newWindow ? '_blank' : ''}>
      <div className="button is-large is-outline border-radius-2" tabIndex="0">
        <span className="navbar-item-name">{text}</span>
      </div>
    </a>
  </div>
)

export default SecondaryButton
